import n5Targets from "../consts/kanjiN5StudyTargets.json";
import evidence from "../consts/kanjiReadingLevels.json";
import { localizeKanjiMeaning } from "../i18n/localizedKanji";

type Details = { kunyomi?: string[]; onyomi?: string[] };
type Entry = { symbol: string; meaning: string; englishMeaning?: string; jlptLevel?: number | null };
type Target = { meaning: string; ptMeaning: string; kunyomi: string[]; onyomi: string[] };
type Evidence = Record<string, Record<string, { level: number; source: string }>>;
export type ScopedReading = { reading: string; originalIndex: number };
export function assessmentLevel(selected: string, preferred?: string | null): number {
    const candidate = Number(selected === "all" ? preferred : selected);
    return Number.isInteger(candidate) && candidate >= 1 && candidate <= 5 ? candidate : 5;
}

// Cumulative study targets: an N4 learner also knows the N5 foundation.
// Unmapped dictionary readings/senses remain optional at every level.
export function kanjiStudyScope(entry: Entry, details: Details | null | undefined, level: number, language: string) {
    const target = (n5Targets as Record<string, Target>)[entry.symbol];
    const withinLevel = Boolean(entry.jlptLevel && entry.jlptLevel >= level);
    const required = { kunyomi: [] as ScopedReading[], onyomi: [] as ScopedReading[] };
    const advanced = { kunyomi: [] as string[], onyomi: [] as string[] };
    for (const kind of ["kunyomi", "onyomi"] as const) {
        (details?.[kind] || []).forEach((reading, originalIndex) => {
            const tag = (evidence as Evidence)[entry.symbol]?.[`${kind}:${reading}`];
            if (withinLevel && tag && tag.level >= level) required[kind].push({ reading, originalIndex });
            else advanced[kind].push(reading);
        });
    }
    const english = entry.englishMeaning || entry.meaning;
    const englishMeaning = !withinLevel ? "" : target ? target.meaning : english.split(",")[0].trim();
    const meaning = !englishMeaning ? "" : target ? language === "pt" ? target.ptMeaning : target.meaning : localizeKanjiMeaning(entry.symbol, english, language).split(",")[0].trim();
    const coreParts = new Set(englishMeaning.toLowerCase().split(",").map(part => part.trim()));
    const advancedMeaning = english.split(",").map(part => part.trim()).filter(part => !coreParts.has(part.toLowerCase())).join(", ");
    return { required, advanced, meaning, englishMeaning, advancedMeaning, eligible: Boolean(englishMeaning || required.kunyomi.length || required.onyomi.length) };
}
